import { useFieldArray, useFormContext } from "react-hook-form";
import { CardView } from "../../../../_components/Abstractions/CardView";
import { HorizontalView } from "../../../../_components/Abstractions/HorizontalView";
import { WastesSelect } from "./WastesSelect";
import { WastesKindMultiSelect } from "./WastesKindMultiSelect";

export function ContractorWastesWasteKindForm() {
  const { fields, remove } = useFieldArray({ name: "wastes" });
  const { watch, getFieldState } = useFormContext();
  const fieldState = getFieldState("wastes");
  const type = watch("type");
  const isPurchase = type === "Purchase";
  // const GetFieldName = (fieldName, index) => `wastes[${index}].${fieldName}`;
  return <>
    <CardView headerText="Towary" headerTypo="h5">
      <div className="domain-control error mb-2">{fieldState?.error?.message}</div>
      {fields?.map((x, index) => (
        <WasteKindForm key={x.id} wasteId={x.waste.wasteId} index={index} isPurchase={isPurchase} onRemove={remove}/>
      ))}
    </CardView>
  </>;
}

const WasteKindForm = ({ index, onRemove, isPurchase, wasteId, waste }) => {
  const GetFieldName = (fieldName, index) => `wastes[${index}].${fieldName}`;
  // const GetWasteKindFieldName = (fieldName, kindIndex) => GetFieldName(`kinds[${kindIndex}].${fieldName}`, index);
  // const { fields, append, remove } = useFieldArray({ name: GetFieldName("kinds", index) });
  // const addItem = () => {
  //   append({
  //     name: "",
  //   });
  // };

  return <>
    <HorizontalView columnsSize={[7, 3, 2]}>
      <WastesSelect name={GetFieldName("waste", index)} label="Towar" skipInitLoading readonly/>
    </HorizontalView>
    <div className="mb-2">
      <WastesKindMultiSelect name={GetFieldName("wasteKinds", index)} wasteId={wasteId}/>
      {/*{fields?.map((wasteKind, kindIndex) => (*/}
      {/*  <HorizontalView key={wasteKind.id}>*/}
      {/*    <FormControl name={GetWasteKindFieldName("name", kindIndex)} label="Nazwa"/>*/}
      {/*    <DomainButton className="mt-2" size="small" onClick={() => remove(kindIndex)}>Usuń</DomainButton>*/}
      {/*  </HorizontalView>*/}
      {/*))}*/}
      {/*<DomainButton size="small" onClick={addItem}>Nowy gatunek</DomainButton>*/}
    </div>
  </>
}
